<template>
  <div>
    <b-container fluid id="bindInfoContainer">
      <b-row>
        <b-col cols="4">中文姓名</b-col>
        <b-col cols="8">{{ExcistLead.ChineseName}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">行動電話</b-col>
        <b-col cols="8">{{ExcistLead.PhoneNumber}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="4">Email</b-col>
        <b-col cols="8">{{ExcistLead.Email}}</b-col>
      </b-row>
    </b-container>
    <b-container id="bind">
      <b-row>
        <b-col class="bindtip">此名單已存在，但目前沒有主聯業務。要使用此名單嗎?</b-col>
      </b-row>
      <b-row>
        <b-col style="text-align:center;padding: 0px;">
          <b-form-group>
            <b-container fluid>
              <b-row>
                <b-col cols="6" style="padding-left: 0px;">
                  <b-button variant="danger" @click="addSalesTraceStatusAndGoToLeadInfo()" block>是</b-button>
                </b-col>
                <b-col cols="6" style="padding-right: 0px;">
                  <b-button variant="danger" @click="backToCheck()" block>否</b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { LeadHandler } from "@/handler/LeadHandler.js";
import store from "@/vuex/store_lead.js";
export default {
  props: ["tutorChatToken"],
  data() {
    return {};
  },
  methods: {
    addSalesTraceStatusAndGoToLeadInfo: function() {
      let loadingInstance = Loading.service({ fullscreen: true });
      LeadHandler.addSalesTraceStatus(this.ExcistLead.Sn, this.tutorChatToken);
      loadingInstance.close();
      store.dispatch("setDisplayToDefult");

      window.location.href =
        "#/MobileLeadInfoView?ls=" +
        this.ExcistLead.Sn;
    },
    backToCheck: function() {
      store.dispatch("setDisplayToDefult");
    }
  },
  computed: {
    ExcistLead() {
      return store.state.checkLeadResult.ExcistLead;
    }
  }
};
</script>

<style scoped>
#bindInfoContainer .row {
  height: 12.5%;
}
#bindInfoContainer .row div {
  line-height: 350%;
}
#bindInfoContainer .row .col-8 {
  padding-left: 0px;
}
#bindInfoContainer .row .col-3 {
  padding-left: 0px;
}
#bindInfoContainer {
  height: 40%;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 10px 15px;
}
#bind {
  height: 60%;
}
#bindInfoContainer > div > div:first-child {
  color: #aaa;
  font-weight: bold;
  position: relative;
}

#bindInfoContainer > div > div:first-child:after {
  content: "／";
  font-weight: normal;
  color: #ddd;
  position: absolute;
  left: 80px;
  top: 0;
}

#bindInfoContainer .row div {
  line-height: 40px;
}

.btn {
  float: right;
  font-size: 13px;
  background: #b20404;
}

.bindtip {
  font-size: 15px;
  margin: 25px 0 10px;
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/CreateLead_Bind.vue